import React, { PropsWithChildren } from 'react'
import { Flex } from '@chakra-ui/react'
import { useMessageProperties } from '../message-provider'
import ExportSelectWrapper from '../export-select-wrapper'

export default function PlacementWrapper({ children }: PropsWithChildren) {
    const { isCurrentUser } = useMessageProperties()

    return (
        <ExportSelectWrapper>
            <Flex
                flexDir="column"
                w="full"
                alignSelf={isCurrentUser ? 'flex-end' : 'flex-start'}
                alignItems={isCurrentUser ? 'flex-end' : 'flex-start'}
            >
                {children}
            </Flex>
        </ExportSelectWrapper>
    )
}
